import { render, staticRenderFns } from "./ProjectsModal.vue?vue&type=template&id=362ed18f&scoped=true&"
import script from "./ProjectsModal.vue?vue&type=script&lang=js&"
export * from "./ProjectsModal.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsModal.vue?vue&type=style&index=0&id=362ed18f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362ed18f",
  null
  
)

export default component.exports